import { connect } from 'react-redux';
import { Piece } from '../piece';
import { getPiece } from '../project';

const container = connect((state, { pieceID }) => getPiece(state, pieceID));

export default container(Piece);
